import { render, staticRenderFns } from "./noteCard.vue?vue&type=template&id=530ffc2d&scoped=true&"
import script from "./noteCard.vue?vue&type=script&lang=js&"
export * from "./noteCard.vue?vue&type=script&lang=js&"
import style0 from "./noteCard.vue?vue&type=style&index=0&id=530ffc2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ffc2d",
  null
  
)

export default component.exports